module.exports = __webpack_public_path__ + "static/img/thumb-abandoned.e461da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-abandoned.png
// module id = 82
// module chunks = 0